import styled from 'styled-components';

import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';

export const Content = styled(IndentContainer)`
    position: relative;
    height: 100%;
    transition: all .25s;
    overflow: hidden;
`;

export const ScrollbarCustomStyles = {
    view: { paddingRight: 0, paddingBottom: 0 },
    trackVertical: { top: '24px', bottom: '24px' },
    thumbVertical: { height: '20px' },
};
